import Flickity from "flickity";

const initSpeakersCarousels = (sections) => {
    sections.forEach((section) => {
        const flickityOptions = {
            cellAlign: "left",
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            lazyLoad: true,
            imagesLoaded: true,
            watchCSS: true
        };
        const carousel = new Flickity(section, flickityOptions);

        carousel.on('staticClick', (event, pointer, cellElement) => {
            if (!cellElement) return;

            const button = cellElement.querySelector('button');
            if (button) {
                button.click();
            }
        });
    });
};

export default initSpeakersCarousels;
